import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular';
import OneSignal from 'onesignal-cordova-plugin';
import { ModelLocatorService } from '../services/config/model-locator.service';

/**
 * Serviço de push via OneSignal
 * @author Starley Cazorla
 */

@Injectable()
export class OneSignalProvider {

    constructor(public platform: Platform,
        private modelLocator: ModelLocatorService) {
    }

    /**
    * Configura oneSignal
    */
    async setupPushOneSignal() {
        if (Capacitor.getPlatform() !== 'web') {
            console.log('--- One Signal ---');

            // I recommend to put these into your environment.ts
            OneSignal.initialize('4add595c-d7f6-44e3-8f64-344c55ad6dc2');

            OneSignal.Notifications.addEventListener('click', async (e) => {
                let clickData = await e.notification;
                console.log("Notification Clicked : " + clickData);
            })

            OneSignal.Notifications.requestPermission(true).then((success: Boolean) => {
                console.log("Notification permission granted " + success);
            })

            OneSignal.Debug.setLogLevel(6)
        }
    }

    /**
     * Sends tags one signal
     * @author Starley Cazorla
     */
    async sendTagsOneSignal() {
        try {
            if (this.platform.is('cordova')) {
                const oneSignalIdentification = {
                    cpf: this.modelLocator.dadosLogin.cpf,
                    idperfil: this.modelLocator.dadosLogin.idperfil,
                    ltm_id: this.modelLocator.dadosLogin.ltm_id,
                    perfil: this.modelLocator.dadosLogin.perfil,
                    idowner: this.modelLocator.dadosLogin.idowner,
                    documentacao: this.modelLocator.dadosLogin.documentacao ?? '',
                    classificacao: this.modelLocator.dadosLogin.classificacao ?? '',
                    tags: JSON.stringify(this.modelLocator.dadosLogin.tags) || '',
                    id_rede: this.modelLocator.dadosLogin.id_rede ?? ''
                };
                OneSignal.User.addTags(oneSignalIdentification);
            }
        } catch (error) {
            console.log("🚀 ~ file: login-service.service.ts:63 ~ LoginService ~ sendTagsOneSignal ~ error:", error)
        }
    }

}
